<template>
  <div class="">
    <el-header style="padding: 0px;display:flex;justify-content:flex-end;align-items: center">
      <el-select v-model="filterParams.cityCode" style="width:300px;" @change="cityChange" filterable clearable placeholder="请选择城市">
        <el-option
          v-for="item in cityOptions"
          :key="item.codeItemId"
          :label="item.codeName"
          :value="item.codeItemId">
        </el-option>
      </el-select>
      <el-button v-waves class="filter-item" type="primary" size="mini" icon="el-icon-search" style="margin-left: -5px;z-index:1" @click="searchProduct()">搜索</el-button>
      <div style="margin-left: 10px;display: inline">
        <el-button
          type="primary"
          size="mini"
          @click="handleAdd">
          新增
        </el-button>
      </div>
    </el-header>
    <iTable
      :data="dataList"
      :col-configs="colConfigs"
      :default-sort="{prop: 'age', order: 'descending'}"
      :row-class-name="tableRowClassName"
      :row-click="clickRowEvent"
      :max-height="maxHeight"
      :select="selectCheck"
      :show-loading="isLoading"
      :table-key="tableKey"
      :selection-change="handleSelectionChange"
      :filter-change="handleFilterChange"
      :sort-change="handleSortChange"
      itable-loading="loading"
      row-key="id"
    >
      <el-table-column slot="selection" align="center" type="selection" width="50" fixed="left"/>
      <el-table-column slot="index" :formatter="formatterIndex" label="序号" align="center" width="50" fixed="left"/>
      <el-table-column slot="status" label="状态"  align="center">
        <template slot-scope="scope">
          <el-switch
            active-color="#519eff"
            inactive-color="#cccccc"
            :active-value="1"
            :inactive-value="0"
            v-model="scope.row.status"
            @change="apprStatusChange(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column slot="operate" label="操作" width="180" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click.stop="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click.stop="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </iTable>
    <el-pagination
      :current-page="page.currentPage"
      :page-sizes="page.pageSizes"
      :total="page.total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"/>
  </div>
</template>
<script>
    /* eslint-disable handle-callback-err */
    import waves from '@/directive/waves' // Waves directive
    import iTable from '@/components/table/index'
    import { citys } from '@/const/city.js';
    import { getApprListpage,delApprInfoById,updateProcess} from  "@/api/appr/apprInfo"
    export default {
        components: { iTable },
        directives: { waves },
        data() {
            return {
                showAddAdminVisible: false,
                operDisabled: true,
                selection: [], // 选中的数据
                maxHeight: null,
                clientHeight: null,
                dataList: [],
                cityOptions:citys,
                page: {
                    pageSizes: [10,20,30,50],
                    total: 0,
                    currentPage: 1,
                    currentPages: 0,
                    pageSize: 10
                },
                isLoading: true,
                dialogVisible: false,
                showFooter: false, // 是否显示弹框的底部按钮
                fixFooter: true, // 是否固定显示组件内的footer按钮
                beginDateScope: '',
                faangledoubleup: 'fa-angle-double-up',
                faangledoubledown: 'fa-angle-double-down',
                filterParams: {
                    cityCode: ''
                },
                tableKey: 'table1' // 区分唯一性  solt渲染时需要对应的key
            }
        },
        computed: {
            // 注意！！！colConfigs不能放在data 里面，因为当语言切换的时候 他是不会变的 ，要写在computed内
            colConfigs() {
                return [
                    { slot: 'index' }, // 序号列
                    { prop: 'name', label: '所属城市', align: 'center' },
                    { slot: 'status'},
                    { prop: 'createTime', label: '创建时间', align: 'center', width:'150' },
                    { slot: 'operate' } // 操作
                ]
            }
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function() {
                this.changeFixed(this.clientHeight)
            }
        },
        mounted() {
            this.initData()
        },
        methods: {
            initData() {
                const that = this
                // 获取浏览器可视区域高度
                that.$set(that, 'clientHeight', `${document.documentElement.clientHeight}`)
                window.onresize = function temp() {
                    that.$set(that, 'clientHeight', `${document.documentElement.clientHeight}`)
                }
                that.loadProduct()
            },
            searchProduct() {
                this.page.currentPage = 1
                this.loadProduct()
            },
            // 给行加行号
            tableRowClassName({ row, rowIndex }) {
                // 把每一行的索引放进row
                row.index = rowIndex
            },
            formatterIndex(row, column, cellValue, index) {
                // 放回索引值
                return this.page.currentPages * (this.page.pageSize - 1) + 1 + row.index
            },
            // 点击行事件
            clickRowEvent(row, column, event) {
                console.log(row)
                console.log(column)
                console.log(event)
            },

            // 选中复选框事件
            selectCheck(selection, row) {
                // 你可以这样修改行数据值
                // selection[0].id = '123'
                console.log(selection)
                console.log(row)
            },
            handleSelectionChange(val) {
                this.selection = val
                if (val.length > 0) {
                    this.operDisabled = false
                } else {
                    this.operDisabled = true
                }
            },

            // 表格最大高自适应
            changeFixed(clientHeight) {
                // 导航栏高65+边距上下30*2+ el-table 链接高40 + 分页高32 = 183
                this.$set(this, 'maxHeight', clientHeight - 197)
            },
            // 页码变化时
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`)
                // 切换成每页20条的数据
                this.page.pageSize = val
                this.isLoading=true
                this.loadProduct()
            },
            // 当前页变化时
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`)
                // 获取table数据
                this.page.currentPage = val
                this.isLoading=true
                this.loadProduct()
            },
            loadProduct() {
                let params = this.filterParams;
                params.page= this.page.currentPage;
                params.limit = this.page.pageSize;
                getApprListpage(params).then(res => {
                    this.page.total = res.data.total
                    this.dataList = res.data.records
                    this.isLoading = false
                })
            },
            // 当talbel中任何一列的过滤条件点击确定和覆盖时，都会触发此事件。
            handleFilterChange(filters) {
                // 拷贝filters的值。
                for (const i in filters) {
                    const row = i // 保存 column-key的值，如果事先没有为column-key赋值，系统会自动生成一个唯一且恒定的名称
                    const val = filters[i]
                    if (val != null && val.length > 0) {
                        this.$set(this.filterParams, row, val[0])
                    } else {
                        this.$set(this.filterParams, row, '')
                    }
                }
                this.currentPage = 1
                this.loadProduct()
            },
            apprStatusChange(row){
                //更新状态
                this.loading = true;
                updateProcess({"id":row.id,"status":row.status}).then(res =>{
                    this.loading = false;
                    if(res.data.code == 0){
                        this.$message.success("修改成功");
                    }
                })
            },
            // 新增
            handleAdd() {
              this.$router.push({
                  path: '/appr/setting',
                  query: {
                  }}
              );
            },
            // 详情
            handleEdit(index, row) {
              this.$router.push({
                  path: '/appr/setting',
                  query: {
                      id: row.id
                  }}
              );
            },
            // 详情
            handleDelete(index, row) {
                this.$confirm("删除将无法恢复，确认删除该流程吗？","提示" , {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: 'warning'
                }).then(() => {
                    //删除
                    this.loading = true;
                    delApprInfoById(row.id).then(res =>{
                        this.loading = false;
                        if(res.data.code == 0 ){
                            this.$message.success("删除成功");
                            this.loadProduct();
                        }
                    })
                })
            }
        }
    }
</script>
<style scoped>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-input--mini .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
</style>
